import type { ITrainerInvitationDto } from '@treneo/models';

import type { GridColDef } from '@mui/x-data-grid';

import { createOrganizationInvitationsColumns as createSharedOrganizationInvitationsColumns } from './invitation-columns.utils';

export type { FormatDateTimeFn } from './invitation-columns.utils';

export type CreateOrganizationInvitationsColumnsParams = {
  t: (key: string) => string;
  formatDateTime: import('./invitation-columns.utils').FormatDateTimeFn;
  onCancelInvitation?: (invitationId: string) => void;
  isCancelling?: boolean;
  organizationId: string;
};

export const createOrganizationInvitationsColumns = (
  params: CreateOrganizationInvitationsColumnsParams
): GridColDef<ITrainerInvitationDto>[] => {
  const onCancelInvitation = params.onCancelInvitation;
  const onCancel =
    onCancelInvitation == null
      ? undefined
      : (_organizationId: string, invitationId: string) => onCancelInvitation(invitationId);
  return createSharedOrganizationInvitationsColumns({
    t: params.t,
    formatDateTime: params.formatDateTime,
    isCancelling: params.isCancelling,
    onCancelInvitation: onCancel,
    getCancelParams: row => ({ organizationId: params.organizationId, invitationId: row.id })
  }) as GridColDef<ITrainerInvitationDto>[];
};
